'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.experimental = exports.default = exports.DeckGL = exports.ExtrudedChoroplethLayer64 = exports.ChoroplethLayer64 = exports.ChoroplethLayer = exports.GeoJsonLayer = exports.PolygonLayer = exports.PathLayer = exports.HexagonCellLayer = exports.HexagonLayer = exports.GridCellLayer = exports.GridLayer = exports.ScreenGridLayer = exports.ScatterplotLayer = exports.PointCloudLayer = exports.LineLayer = exports.IconLayer = exports.ArcLayer = exports.WebMercatorViewport = exports.OrthographicViewport = exports.PerspectiveViewport = exports.Viewport = exports.COORDINATE_SYSTEM = exports.AttributeManager = exports.LayerManager = exports.CompositeLayer = exports.Layer = exports.assembleShaders = undefined;

var _shaderUtils = require('./shader-utils');

Object.defineProperty(exports, 'assembleShaders', {
  enumerable: true,
  get: function get() {
    return _shaderUtils.assembleShaders;
  }
});

var _lib = require('./lib');

Object.defineProperty(exports, 'Layer', {
  enumerable: true,
  get: function get() {
    return _lib.Layer;
  }
});
Object.defineProperty(exports, 'CompositeLayer', {
  enumerable: true,
  get: function get() {
    return _lib.CompositeLayer;
  }
});
Object.defineProperty(exports, 'LayerManager', {
  enumerable: true,
  get: function get() {
    return _lib.LayerManager;
  }
});
Object.defineProperty(exports, 'AttributeManager', {
  enumerable: true,
  get: function get() {
    return _lib.AttributeManager;
  }
});
Object.defineProperty(exports, 'COORDINATE_SYSTEM', {
  enumerable: true,
  get: function get() {
    return _lib.COORDINATE_SYSTEM;
  }
});

var _viewport = require('./lib/viewports/viewport');

Object.defineProperty(exports, 'Viewport', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_viewport).default;
  }
});

var _perspectiveViewport = require('./lib/viewports/perspective-viewport');

Object.defineProperty(exports, 'PerspectiveViewport', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_perspectiveViewport).default;
  }
});

var _orthographicViewport = require('./lib/viewports/orthographic-viewport');

Object.defineProperty(exports, 'OrthographicViewport', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_orthographicViewport).default;
  }
});

var _webMercatorViewport = require('./lib/viewports/web-mercator-viewport');

Object.defineProperty(exports, 'WebMercatorViewport', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_webMercatorViewport).default;
  }
});

var _arcLayer = require('./layers/core/arc-layer/arc-layer');

Object.defineProperty(exports, 'ArcLayer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_arcLayer).default;
  }
});

var _iconLayer = require('./layers/core/icon-layer/icon-layer');

Object.defineProperty(exports, 'IconLayer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_iconLayer).default;
  }
});

var _lineLayer = require('./layers/core/line-layer/line-layer');

Object.defineProperty(exports, 'LineLayer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_lineLayer).default;
  }
});

var _pointCloudLayer = require('./layers/core/point-cloud-layer/point-cloud-layer');

Object.defineProperty(exports, 'PointCloudLayer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_pointCloudLayer).default;
  }
});

var _scatterplotLayer = require('./layers/core/scatterplot-layer/scatterplot-layer');

Object.defineProperty(exports, 'ScatterplotLayer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_scatterplotLayer).default;
  }
});

var _screenGridLayer = require('./layers/core/screen-grid-layer/screen-grid-layer');

Object.defineProperty(exports, 'ScreenGridLayer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_screenGridLayer).default;
  }
});

var _gridLayer = require('./layers/core/grid-layer/grid-layer');

Object.defineProperty(exports, 'GridLayer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_gridLayer).default;
  }
});

var _gridCellLayer = require('./layers/core/grid-cell-layer/grid-cell-layer');

Object.defineProperty(exports, 'GridCellLayer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_gridCellLayer).default;
  }
});

var _hexagonLayer = require('./layers/core/hexagon-layer/hexagon-layer');

Object.defineProperty(exports, 'HexagonLayer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_hexagonLayer).default;
  }
});

var _hexagonCellLayer = require('./layers/core/hexagon-cell-layer/hexagon-cell-layer');

Object.defineProperty(exports, 'HexagonCellLayer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_hexagonCellLayer).default;
  }
});

var _pathLayer = require('./layers/core/path-layer/path-layer');

Object.defineProperty(exports, 'PathLayer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_pathLayer).default;
  }
});

var _polygonLayer = require('./layers/core/polygon-layer/polygon-layer');

Object.defineProperty(exports, 'PolygonLayer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_polygonLayer).default;
  }
});

var _geojsonLayer = require('./layers/core/geojson-layer/geojson-layer');

Object.defineProperty(exports, 'GeoJsonLayer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_geojsonLayer).default;
  }
});

var _choroplethLayer = require('./layers/deprecated/choropleth-layer/choropleth-layer');

Object.defineProperty(exports, 'ChoroplethLayer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_choroplethLayer).default;
  }
});

var _choroplethLayer2 = require('./layers/deprecated/choropleth-layer-64/choropleth-layer-64');

Object.defineProperty(exports, 'ChoroplethLayer64', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_choroplethLayer2).default;
  }
});

var _extrudedChoroplethLayer = require('./layers/deprecated/extruded-choropleth-layer-64/extruded-choropleth-layer-64');

Object.defineProperty(exports, 'ExtrudedChoroplethLayer64', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_extrudedChoroplethLayer).default;
  }
});

var _deckgl = require('./react/deckgl');

Object.defineProperty(exports, 'DeckGL', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_deckgl).default;
  }
});
Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_deckgl).default;
  }
});

var _get = require('./lib/utils/get');

var _count = require('./lib/utils/count');

var _lib2 = require('./experimental/lib');

var _reflectionEffect = require('./experimental/effects/reflection-effect');

var _reflectionEffect2 = _interopRequireDefault(_reflectionEffect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Experimental Features (May change in minor version bumps, use at your own risk)


var experimental = exports.experimental = {
  get: _get.get,
  count: _count.count,
  EffectManager: _lib2.EffectManager,
  Effect: _lib2.Effect,
  ReflectionEffect: _reflectionEffect2.default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./~/deck.gl/dist/index.js
// module id = 256
// module chunks = 0